var t = document.querySelectorAll('.variant_id_shade');
t.forEach((e, r) => {
  e.addEventListener('click', (e) => {
    var r = e.target.getAttribute('data-section-id'),
      a = e.target.getAttribute('data-shade-id'),
      n = e.target.getAttribute('data-shade-title'),
      c = e.target.getAttribute('data-product-id'),
      i = e.target.getAttribute('data-variant-image'),
      l = e.target.getAttribute('data-variant-srcset'),
      o = document.getElementById(`${r}-shade-name-${c}`),
      d = document.getElementById(`${r}-variant-selected-${c}`),
      u = document.getElementById(`${r}-variant-image-${c}`),
      p = document.getElementById(`${r}-variant-price-${c}`);
    t.forEach((e, t) => {
      e.style.border = '1px solid #ccc';
    }),
      (e.target.style.border = '2px solid #000'),
      (d.value = a),
      (o.innerHTML = `<span><i>${n}</i></span>`),
      (p.innerHTML = `${e.target.getAttribute('data-variant-price')}`),
      i && ((u.src = i), (u.srcset = l));
  });
});